import { Component, HostBinding, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { NotificationPage } from '@portal-core/notifications/models/notification-page.model';
import { Notification } from '@portal-core/notifications/models/notification.model';
import { NotificationList } from '@portal-core/notifications/util/notification-list';
import { filter } from 'lodash';
import { Observable } from 'rxjs';
import { NotificationListComponent } from '@portal-core/notifications/components/notification-list/notification-list.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'mc-user-notification-list',
    templateUrl: './user-notification-list.component.html',
    styleUrls: ['./user-notification-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NotificationListComponent, NgIf, MatButton, MatProgressBar, AsyncPipe]
})
export class UserNotificationListComponent extends NotificationList implements OnChanges {
  @HostBinding('class.mc-notification-list') hostClass: boolean = true;
  @Input() licenseUser: LicenseUser;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licenseUser) {
      this.onConfigurationChanged();
    }
  }

  protected isConfigured(): boolean {
    return this.licenseUser && (typeof this.licenseUser.LicenseId === 'number' && !!this.licenseUser.User.Id);
  }

  protected fetchNotifications$(pageSize: number, pageIndex: number): Observable<NotificationPage> {
    return this.notificationsService.getNotificationsByUserIdAndLicenseId$(this.licenseUser.User.Id, this.licenseUser.LicenseId, pageSize, pageIndex);
  }

  protected filterNotifications(notifications: { [id: string]: Notification }): Notification[] {
    return filter(notifications, (notification: Notification) => {
      return (notification.LicenseId === this.licenseUser.LicenseId || typeof notification.LicenseId !== 'number') &&
        (notification.InvokerUserId === this.licenseUser.User.Id || notification.UserId === this.licenseUser.User.Id);
    });
  }
}
